import 'css-chunksrc/client/common/layout/navigation/styles.scss';export default {
  "navigation": "_navigation_1a9fq_1",
  "border": "_border_1a9fq_7",
  "item": "_item_1a9fq_12",
  "openedZones": "_openedZones_1a9fq_12",
  "zones": "_zones_1a9fq_18",
  "link": "_link_1a9fq_22",
  "zonesLink": "_zonesLink_1a9fq_39",
  "subLink": "_subLink_1a9fq_43",
  "subMenuItems": "_subMenuItems_1a9fq_56",
  "selectedLink": "_selectedLink_1a9fq_64",
  "icon": "_icon_1a9fq_71",
  "eventIcon": "_eventIcon_1a9fq_79",
  "managementIcon": "_managementIcon_1a9fq_83",
  "arrowIcon": "_arrowIcon_1a9fq_92",
  "subManagementMenu": "_subManagementMenu_1a9fq_99",
  "push": "_push_1a9fq_108",
  "mainDropdown": "_mainDropdown_1a9fq_112",
  "resourcesName": "_resourcesName_1a9fq_118",
  "closed": "_closed_1a9fq_122",
  "name": "_name_1a9fq_122",
  "buttonRedirectZonePage": "_buttonRedirectZonePage_1a9fq_178",
  "buttonCreateZone": "_buttonCreateZone_1a9fq_181",
  "redirectZonePage": "_redirectZonePage_1a9fq_214",
  "activeLink": "_activeLink_1a9fq_226",
  "iconZone": "_iconZone_1a9fq_235",
  "zoneList": "_zoneList_1a9fq_261",
  "iconZoneCollapse": "_iconZoneCollapse_1a9fq_267",
  "buttonCreateZoneCollapse": "_buttonCreateZoneCollapse_1a9fq_276",
  "iconAdd": "_iconAdd_1a9fq_290",
  "selectAllZone": "_selectAllZone_1a9fq_298"
};